module.exports = __webpack_public_path__ + "img/our-story.6b72dc24.jpg";